/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions
  },
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  SET_FEEDBACKS(state, feedbacks) {
    state.feedbacks = feedbacks
  },
}
